<template>
  <button
    type="button"
    class="action-arrow-button"
    :class="[`variant-${variant}`, `desc-${descPosition}`, { deprecated, blocked }]"
    :title="title || label"
    :disabled="blocked"
    @click="handleClick"
  >
    <span class="icon-container">
      <slot></slot>
    </span>
    <span class="desc">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: "ActionArrowButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
    blocked: {
      type: Boolean,
      default: false,
    },
    deprecated: {
      type: Boolean,
      default: false,
    },
    descPosition: {
      type: String,
      default: "top",
    },
  },
  methods: {
    handleClick(event) {
      if (this.blocked) {
        return;
      }
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.action-arrow-button {
  --action-shadow-soft: 0 6px 16px rgba(19, 24, 41, 0.18);
  --action-shadow-raised: 0 12px 28px rgba(19, 24, 41, 0.24);

  z-index: 10;
  box-shadow: var(--action-shadow-soft);
  .default-hover;
  width: 52px;
  height: 52px;
  border-radius: 999px;
  border: 0;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: @vermelho;
  transition: transform 0.16s ease, filter 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;

  &:hover {
    filter: brightness(1.03);
    transform: translateY(-1px);
    box-shadow: var(--action-shadow-raised);

    .desc {
      opacity: 1;
      transform: translateY(0);
      background: @azul;
    }
  }

  &.blocked {
    cursor: not-allowed;
    opacity: 0.65;
  }

  &.deprecated {
    background: @azul;

    &:hover .desc {
      background: @azul;
    }
  }

  .icon-container {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: visible;

    /deep/ i,
    /deep/ svg {
      width: 18px;
      height: 18px;
      font-size: 18px;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
    }
  }

  .desc {
    position: absolute;
    right: 0;
    top: -40px;
    margin: auto;
    display: table;
    font-size: 0.82rem;
    font-weight: 700;
    color: white;
    background: @vermelho;
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    box-shadow: var(--action-shadow-soft);
    opacity: 0;
    white-space: nowrap;
    pointer-events: none;
    transform: translateY(3px);
    transition: opacity 0.16s ease, transform 0.16s ease, background-color 0.16s ease;
    z-index: 999;
  }

  &.desc-left {
    .desc {
      top: 50%;
      right: calc(100% + 8px);
      transform: translateY(-50%);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    &:hover .desc {
      transform: translateY(-50%);
    }
  }

  &.desc-right {
    .desc {
      top: 50%;
      left: calc(100% + 8px);
      right: auto;
      transform: translateY(-50%);
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:hover .desc {
      transform: translateY(-50%);
    }
  }
}
</style>
